import React from 'react'

export default function ContenedorCards(props) {
  return (
    <div key={props.key || ""} className="p-col-12 p-md-4 p-sm-6" onClick={props.onClick}>
      {props.children}
    </div>
  )
}
